/**
 * Выбранное производство в сравнении — правила для МСК Газобетона.
 *
 * Строка сравнения (`entry`) идентифицируется полем `entry.id`, в которое входит
 * позиция сравнения в исходном массиве: `${comparison.id}-other-${comparisonIndex}`.
 * После пересчёта (изменили количество, адрес, выпало производство) позиции
 * сдвигаются, и сохранённый `entry.id` может указать на другую строку.
 *
 * Поэтому выбранное производство хранится ключом сравнения — `comparison.id`.
 * Это имя производителя (см. BackendProductions), и оно:
 *   - не зависит от позиции строки и от сортировки таблицы;
 *   - уникально: сравнения строятся из `Object.entries` номенклатуры,
 *     то есть по одному сравнению на производителя.
 *
 * Здесь только сопоставление. Ни расчёта, ни выбора оффера, ни идентификаторов
 * строк эти функции не меняют: `entry.id` остаётся прежним для всех калькуляторов.
 */

/** Ключ, под которым запоминается выбранное предложение. */
export const getSelectedComparisonKey = (comparison, entry) => {
  const key = comparison?.id ?? entry?.comparison?.id ?? null;
  return key === null || key === undefined || key === "" ? null : key;
};

/**
 * Выбранное предложение всё ещё есть в пересчитанных сравнениях.
 * Если нет — помечать вместо него соседнюю строку нельзя, выбор отдаётся
 * существующему автовыбору дешевейшего варианта.
 */
export const isSelectedComparisonPresent = (comparisons, selectedComparisonId) => {
  if (selectedComparisonId === null || selectedComparisonId === undefined) {
    return false;
  }
  if (!Array.isArray(comparisons) || comparisons.length === 0) {
    return false;
  }
  return comparisons.some((comparison) => comparison?.id === selectedComparisonId);
};

/**
 * Строку нужно пометить как выбранную. Вне МСК Газобетона — всегда false:
 * там метки нет, и новое состояние выбора не используется.
 */
export const isSelectedComparisonRow = ({
  isMskGazobetonScope,
  comparison,
  selectedComparisonId,
} = {}) => {
  if (!isMskGazobetonScope) {
    return false;
  }
  if (selectedComparisonId === null || selectedComparisonId === undefined) {
    return false;
  }
  const key = comparison?.id;
  return key !== null && key !== undefined && key === selectedComparisonId;
};

export default isSelectedComparisonRow;
